function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! License details at fancyapps.com/license */
import { isPlainObject as t } from "../utils/isPlainObject.js";
import { isString as e } from "../utils/isString.js";
import { stringToHtml as o } from "../utils/strToHtml.js";
import { PanzoomButtons as n } from "../shared/buttons.js";
import { extend as i } from "../utils/extend.js";
var l;
!function (t) {
  t.Left = "left", t.middle = "middle", t.right = "right";
}(l || (l = {}));
var s = Object.assign({
    counter: {
      tpl: '<div class="f-counter"><span data-carousel-page></span>/<span data-carousel-pages></span></div>'
    },
    download: {
      tpl: '<button data-carousel-download class="f-button" title="{{DOWNLOAD}}"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></button>'
    },
    autoplay: {
      tpl: '<button data-autoplay-action="toggle" class="f-button" title="{{TOGGLE_AUTOPLAY}}"><svg><g><path d="M5 3.5 19 12 5 20.5Z"/></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
    },
    thumbs: {
      tpl: '<button data-thumbs-action="toggle" class="f-button" title="{{TOGGLE_THUMBS}}"><svg><rect width="18" height="14" x="3" y="3" rx="2"/><path d="M4 21h1M9 21h1M14 21h1M19 21h1"/></svg></button>'
    }
  }, n),
  a = {
    absolute: !1,
    display: {
      left: [],
      middle: ["zoomIn", "zoomOut", "toggle1to1", "rotateCCW", "rotateCW", "flipX", "flipY", "reset"],
      right: []
    },
    enabled: "auto",
    items: {}
  },
  r = function r() {
    var l, r;
    function u(e) {
      var o = null == l ? void 0 : l.getOptions().Toolbar;
      var n = (t(o) ? Object.assign(Object.assign({}, a), o) : a)[e];
      return n && "function" == typeof n && l ? n(l) : n;
    }
    function d() {
      var t, a, d, c;
      if (!(null == l ? void 0 : l.getOptions().Toolbar)) return;
      if (!l || r) return;
      var f = u("enabled");
      if (!f) return;
      var g = u("absolute"),
        p = l.getSlides().length > 1;
      var b = !1,
        m = !1;
      var _iterator = _createForOfIteratorHelper(l.getSlides()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t4 = _step.value;
          _t4.panzoomRef && (b = !0), (_t4.downloadSrc || "image" === _t4.type && _t4.src) && (m = !0);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var v = (null === (t = l.getPlugins().Thumbs) || void 0 === t ? void 0 : t.isEnabled()) || !1,
        h = p && l.getPlugins().Autoplay || !1,
        y = l.getPlugins().Fullscreen && (document.fullscreenEnabled || document.webkitFullscreenEnabled);
      if ("auto" === f && (f = b), !f) return;
      r = (null === (a = l.getContainer()) || void 0 === a ? void 0 : a.querySelector(".f-carousel__toolbar")) || void 0, r || (r = document.createElement("div"), r.classList.add("f-carousel__toolbar"));
      var E = u("display"),
        j = i({}, s, u("items"));
      for (var _i = 0, _arr = ["left", "middle", "right"]; _i < _arr.length; _i++) {
        var _t = _arr[_i];
        var _i2 = E[_t] || [],
          _s = document.createElement("div");
        _s.classList.add("f-carousel__toolbar__column"), _s.classList.add("is-".concat(_t));
        var _iterator2 = _createForOfIteratorHelper(_i2),
          _step2;
        try {
          var _loop = function _loop() {
              var t = _step2.value;
              var i;
              if (e(t)) {
                if ("counter" === t && !p) return 0; // continue
                if ("autoplay" === t && !h) return 0; // continue
                if (n[t] && !b) return 0; // continue
                if ("fullscreen" === t && !y) return 0; // continue
                if ("thumbs" === t && !v) return 0; // continue
                if ("download" === t && !m) return 0; // continue
                i = j[t];
              }
              if ("object" == typeof t && (i = t), i && i.tpl) {
                var _t2 = l.localize(i.tpl);
                _t2 = _t2.split("<svg>").join('<svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24">');
                var _e = o(_t2);
                _e && ("function" == typeof i.click && l && _e.addEventListener("click", function (t) {
                  t.preventDefault(), t.stopPropagation(), "function" == typeof i.click && l && i.click(l, t);
                }), _s.append(_e));
              }
            },
            _ret;
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _ret = _loop();
            if (_ret === 0) continue;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        r.append(_s);
      }
      if (r.childElementCount && (!0 === g && r.classList.add("is-absolute"), null === (d = l.getContainer()) || void 0 === d || d.classList.add("has-toolbar"), !r.parentElement)) {
        var _t3 = u("parentEl");
        _t3 ? _t3.insertAdjacentElement("afterbegin", r) : null === (c = l.getViewport()) || void 0 === c || c.insertAdjacentElement("beforebegin", r);
      }
    }
    return {
      init: function init(t) {
        l = t, l.on("initSlides", d);
      },
      destroy: function destroy() {
        var t;
        null == l || l.off("initSlides", d), null === (t = null == l ? void 0 : l.getContainer()) || void 0 === t || t.classList.remove("has-toolbar"), null == r || r.remove(), r = void 0;
      },
      add: function add(t, e) {
        s[t] = e;
      },
      isEnabled: function isEnabled() {
        return !!r;
      }
    };
  };
export { r as Toolbar, l as ToolbarColumn };